import { apiSlice } from '@/core/api/apiSlice';
import { ApiResponse, PaginatedResponse } from '@/types/common.types';
import { OrganizationQueryParams, Organization, SuperAdminDashboardStats } from '@/types/superAdmin.types';
import { RemoveMemberRequest } from '@/types/admin.types';

export const superAdminApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        superGetOrganizations: builder.query<
            ApiResponse<PaginatedResponse<Organization>>,
            OrganizationQueryParams | void
        >({
            query: (params) => {
                if (!params) return '/admins/super/organizations';
                const searchParams = new URLSearchParams();
                if (params.page) searchParams.append('page', params.page.toString());
                if (params.limit) searchParams.append('limit', params.limit.toString());
                if (params.search) searchParams.append('search', params.search);
                if (params.sortBy) searchParams.append('sortBy', params.sortBy);
                if (params.sortOrder) searchParams.append('sortOrder', params.sortOrder);
                if (params.planFilter) searchParams.append('planFilter', params.planFilter);
                return `/admins/super/organizations?${searchParams.toString()}`;
            },
        }),
        superDeleteOrganization: builder.mutation<ApiResponse<any>, string>({
            query: (orgId) => ({
                url: `/admins/super/organizations/${orgId}`,
                method: 'DELETE',
            }),
        }),
        superRemoveMember: builder.mutation<ApiResponse<any>, RemoveMemberRequest>({
            query: ({ orgId, adminId }) => ({
                url: `/admins/super/organizations/${orgId}/members/${adminId}`,
                method: 'DELETE',
            }),
        }),
        getDashboardStats: builder.query<ApiResponse<SuperAdminDashboardStats>, { days?: number; user_id?: string } | void>({
            query: (params) => {
                if (!params) return '/admins/dashboard';
                const searchParams = new URLSearchParams();
                if (params.days !== undefined) searchParams.append('days', params.days.toString());
                if (params.user_id) searchParams.append('user_id', params.user_id);
                const queryString = searchParams.toString();
                return queryString ? `/admins/dashboard?${queryString}` : '/admins/dashboard';
            },
        }),
    }),
});

export const {
    useSuperGetOrganizationsQuery,
    useSuperDeleteOrganizationMutation,
    useSuperRemoveMemberMutation,
    useGetDashboardStatsQuery,
} = superAdminApi;
